<template>
  <app-layout :account-global-menu="accountGlobalMenu">
    <template #main-content>
      <main id="content" class="l-main p-account">
        <div class="l-main__inner">
          <div class="c-page-header">
            <h1 class="c-page-header-title">お知らせ一覧</h1>
            <button-return @click="goBack" name="S7-1-back-btn">戻る</button-return>
          </div>
          <section>
            <div class="c-parts-box">
              <div class="c-parts-box__inner">
                <ul class="c-news-list" v-if="paginatedNotifications.length!==0">
                  <li :class="{
                      'c-news-list__item': true,
                      'c-news-list__item--open': !!accountStore.alreadyReadNotification[item.uuid]
                    }"
                    v-for="(item, i) in paginatedNotifications"
                    :key="i"
                  >
                    <router-link :to="{name:'notice-detail', params:{uuid: item.uuid}}" class="c-news-list__box" name="S7-1-notice-btn">
                      <div class="c-news-date">
                        <time class="c-news-date__day">{{convertLocalString(item.start_datetime)}}</time>
                        <span class="c-news-date__tag" v-if="item.is_important">重要</span>
                      </div>
                      <p class="title">{{item.title}}</p>
                    </router-link>
                  </li>
                </ul>
                <p class="p-account-no-item" v-if="paginatedNotifications.length===0">お知らせはありません。</p>
              </div>
            </div>
            <div class="c-pagination" v-if="numberOfNotifications > per_page">
              <span @click="goToPrevPage" :class="{'c-pagination__page':true, 'c-pagination__page--prev': true, 'c-pagination__page--disabled': page===1}"></span>
              <span v-for="index in total_page"
                 @click="goToPage(index)"
                 :class="{'c-pagination__page':true, 'c-pagination__page--act': page===index}">{{index}}</span>
              <span @click="goToNextPage" :class="{'c-pagination__page':true, 'c-pagination__page--next':true, 'c-pagination__page--disabled': page===total_page}"></span>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted, computed, onUnmounted} from 'vue';
  import {useRoute, useRouter} from "vue-router"
  import { useAccountStore } from '@/store/student/account_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';

  const route = useRoute()
  const router = useRouter()
  const accountGlobalMenu = ref(true);
  const per_page = ref(10);
  const page = ref(parseInt(route.params.page_number as string));
  const total_page = ref(1);
  const accountStore = useAccountStore()
  const globalNavigationStore = useGlobalNavigationStore() 
  // handle browser back button
  window.addEventListener('popstate', browserBackHandler);

  onMounted(async() => {
    document.title = "お知らせ一覧"
    globalNavigationStore.saveSelectedMenu("acInfo")
    if(numberOfNotifications.value==0){
      await accountStore.fetchAlreadyReadNotifications()
      await accountStore.fetchListNotifications()
    }
    total_page.value = Math.ceil(numberOfNotifications.value/per_page.value) || 1
    if(page.value > total_page.value){
      router.replace({name: 'pageNotFound'}).catch(() => {})
    }
  })

  const numberOfNotifications = computed(() => {
      return accountStore.notificationList.length
  })

  const paginatedNotifications = computed(() => {
    return accountStore.notificationList.slice((page.value-1)*per_page.value, page.value*per_page.value)
  })

  function goBack(){
    globalNavigationStore.saveSelectedMenu(globalNavigationStore.prevSelectedMenu)
    router.go(-1)
  }

  function convertLocalString(date) {
    let dt = new Date(date);
    let y = dt.getFullYear();
    let m = ('00' + (dt.getMonth() +1 )).slice(-2);
    let d = ("00" + dt.getDate()).slice(-2);
    return y + '/' + m + '/' + d;
  }

  function goToPrevPage(){
    page.value = page.value - 1
    router.replace({ name: 'notice', params: { page_number: `${page.value}` } }).catch(()=>{})
  }
  function goToPage(page_number: number){
    page.value = page_number
    router.replace({ name: 'notice', params: { page_number: `${page.value}` } }).catch(()=>{})
  }
  function goToNextPage(){
    page.value = page.value + 1
    router.replace({ name: 'notice', params: { page_number: `${page.value}` } }).catch(()=>{})
  }
  function browserBackHandler() {
    globalNavigationStore.saveSelectedMenu(globalNavigationStore.prevSelectedMenu)
  }
  onUnmounted(() => {
    window.removeEventListener('popstate', browserBackHandler);
  })

</script>
